module.exports = __webpack_public_path__ + "img/63.a7042ee5.png";